import React, {Component} from 'react';
import {connect} from 'react-redux'
import { Button, FormControl, Row, Col, Modal } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import AssetStore from 'stores/AssetStore'
import ConfirmPopup from 'component/element/ConfirmPopup'
import '../stock/Stock.css';
var NotificationSystem = require('react-notification-system');

class AssetEditCategoryModal extends Component {

  constructor(...args) {
    super(...args)
    this.state = {data:[] ,deleteShow:false,indexDelete:-1}
  }

  componentDidMount(){
    this._notificationSystem = this.refs.notificationSystem;
  }

  componentWillReceiveProps(newProps) {
    if (newProps.show&&newProps.show!==this.props.show)
      this.loadData(newProps)
  }

  getData(){
    let {data} = this.state
    return data
  }

  loadData(newProps){
    let that = this
    let {catId,cateAdd} = newProps
    if (cateAdd==='cat_id') {
      AssetStore.loadReportAssetCategory('',function(result) {
        that.setState({data: result.data})
      })
    } else if (cateAdd==='sub_cat_id') {
      AssetStore.loadReportAssetCategory(catId,function(result) {
        that.setState({data: result.data})
      })
    }  
  }

  onNewItemClick(){
    let {data} = this.state
    data.push({name:'',parent_id:'0',cat_id:'0',edit:true})
    this.setState({data:data})
  }

  onEditItemClick(index){
    let {data} = this.state
    data[index].edit = true
    this.setState({data:data})
  }

  onConfirmCatDelete(){
    let {messages,cateAdd} = this.props
    let {indexDelete,data} = this.state
    let that = this
    if(data[indexDelete].cat_id>0){
      let cat_id = data[indexDelete].cat_id
      AssetStore.deleteAssetCategory(cat_id,function(result) {
        data.splice(indexDelete,1);  
        that.setState({data:data,deleteShow:false})  
        if (cateAdd==='cat_id'&&that.props.onUpdateCategory!==undefined)
          that.props.onUpdateCategory(cat_id)
        else if (cateAdd==='sub_cat_id'&&that.props.onUpdateSubCategory!==undefined)
          that.props.onUpdateSubCategory(cat_id)  
      },function(){
        that._notificationSystem.addNotification({
          title:messages['Notification'],
          message: messages['Remove Category Failed, Please Try Again'],
          level: 'error',
          position:'tc'
        });
      })
    }else{
      data.splice(indexDelete,1);  
      that.setState({data:data,deleteShow:false}) 
    }
  }

  onDeleteItemClick(index){
    let {data} = this.state
    let {messages} = this.props
    if(data[index].edit){
      data.splice(index,1);  
      this.setState({data:data})
    }else{
      this.setState({indexDelete:index,deleteShow:true,deleteMsg:messages['Want To Delete Category']+' ['+data[index].name+'] '+messages['Left Out']})
    }
  }

  onCategorySaveClick() {
    let data = this.getData()
    let that = this
    let {messages,catId,cateAdd} = this.props
    AssetStore.saveAssetCategory((cateAdd==='cat_id'?'':catId), data, function (result) {
      if (cateAdd==='cat_id') {
        if (that.props.onNewCategory!==undefined)
          that.props.onNewCategory()
      } else if (cateAdd==='sub_cat_id') {
        if (that.props.onNewSubCategory !== undefined)
          that.props.onNewSubCategory(catId)
      }    
      that.props.onHide()
    }, function () {
      that._notificationSystem.addNotification({
        title: messages['Notification'],
        message: messages['Save Category failed, Please Try Again.'],
        level: 'error',
        position: 'tc'
      });
    })
  }

  onItemChange(index,e){
    let {data} = this.state
    data[index].name = e.target.value
    this.setState({data:data})
  }

  render() {
    let {data,deleteShow,deleteMsg} = this.state
    let {messages,cateAdd,show} = this.props
    return (
      <div>
        <Modal
          id="newAssetCategory" 
          bsSize="large" 
          show={show} 
          onHide={this.props.onHide}
        >
          <Modal.Header closeButton>
            <Modal.Title>{cateAdd==='cat_id'?messages['Add Category']:messages['Add Category']+'ย่อย'}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='table-responsive' style={{marginBottom:'5px'}}>
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th style={{width:'250px'}}>{cateAdd==='cat_id'?messages['Category']:messages['Category']+'ย่อย'}</th>
                    <th style={{width:'100px'}}>{messages['Edit/Delete']}</th>
                  </tr>
                </thead>
                <tbody>
                  {data.length===0?<tr><td colSpan={2}>ไม่พบข้อมูล</td></tr>:data.map((item,index)=>(
                    <tr key={index}>
                      <td>
                        <FormControl type="text" 
                          value={item.name} 
                          readOnly={item.edit!==undefined?!item.edit:true} 
                          onChange={this.onItemChange.bind(this,index)}
                          className="input-dark" 
                        />
                      </td>
                      <td className="text-center">
                        <Row>                    
                          <Col md={12}>
                          <Button className="btn-danger" onClick={this.onDeleteItemClick.bind(this,index)}>
                            <FontAwesome name='trash' /> {messages['Delete']}
                          </Button>
                          </Col>
                        </Row>  
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>  
            <Button className="btn-success" onClick={this.onNewItemClick.bind(this)}>
              <FontAwesome name='plus' /> {messages['Add Item']}
            </Button>
          </Modal.Body>
          <Modal.Footer>
            <Button className="btn-primary" onClick={this.onCategorySaveClick.bind(this)}>
              <FontAwesome name='save' /> {cateAdd==='cat_id'?'บันทึกหมวดหมู่สินค้า':'บันทึกหมวดหมู่สินค้าย่อย'}
            </Button>
            <Button onClick={this.props.onHide}>
              <FontAwesome name='remove' /> ปิด
            </Button>
          </Modal.Footer>
        </Modal>  
        <NotificationSystem ref="notificationSystem" />
        <ConfirmPopup show={deleteShow} 
          title={messages['Confirm']} 
          message={deleteMsg}
          confirmTitle={messages['Confirm']}
          onConfirm={this.onConfirmCatDelete.bind(this)}
          onHide={()=>{this.setState({deleteShow:false})}}        
        />
      </div>
    )
  }
}

export default AssetEditCategoryModal = connect(
  (state) => ({messages: state.message.view.asset.AssetEditCategoryModal}),null,null,{withRef:true}
)(AssetEditCategoryModal);



// WEBPACK FOOTER //
// ./src/view/asset/AssetEditCategoryModal.js